import {api, pdf} from "../../../services/api/api.service";

export const loadEvent = (id, loading) => api({uri: `/events/${id}`, loading});
export const loadCategories = (id, loading) => api({uri: `/events/${id}/categories`, loading});
export const startListPdf = ({id, name}, loading) => pdf({uri: `/categories/${id}/start_list`, loading, filename: `${name}_starts.pdf`});
export const combinedStartListPdf = ({id, name, group}, loading) => pdf({uri: `/categories/${id}/start_list_group_combined`, loading, filename: `${group}_combined_starts.pdf`});